import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29eaefed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "IncludingMajors" }
const _hoisted_2 = { class: "majorsContainer" }
const _hoisted_3 = { class: "majorsLine1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "majorsLine2" }

import {ref, reactive, nextTick} from 'vue'
  import {useRouter, useRoute} from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IncludingMajors',
  props: ['majorArray'],
  setup(__props, { expose }) {

const props = __props;

  let router = useRouter();
  let route = useRoute();

  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileTransferPage/' + route.params.id)
  }

  //获取el-scrollbar 的元素
  let scrollbar = ref();

  

  let goMajorSituation = (n: any) => {
    let id = ref(props.majorArray[n].majorCode);
    // console.log(id.value)
    window.open('/MajorSituation' + '/' + id.value, '_blank')
  };

  let goScrollBar = () => {
    nextTick(() => {
      scrollbar.value!.setScrollTop(0)
    });
  };

  expose({
    goScrollBar
  })


return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, {
    ref_key: "scrollbar",
    ref: scrollbar
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).majorArray, (item, i) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_unref(goMajorSituation)(i))
              }, _toDisplayString(item.majors), 9, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, " 国标代码：" + _toDisplayString(item.majorCode), 1)
          ]))
        }), 256))
      ])
    ]),
    _: 1
  }, 512))
}
}

})